import React, { Component } from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import UtilityService from "../../../../services/UtilityService";

import "./tools-pager.css";

const MOST_PAGE_BUTTONS = 7;

class ToolsPager extends Component {
	pageNumbersToShow() {
		const { page, pageCount } = this.props;
		if (pageCount <= MOST_PAGE_BUTTONS) return Array.from({ length: pageCount }, (_, index) => index + 1);
		const neighbours = [page - 1, page, page + 1].filter(number => number > 1 && number < pageCount);
		const numbers = [1, ...neighbours, pageCount];
		const withGaps = [];
		numbers.forEach((number, index) => {
			const previous = numbers[index - 1];
			if (previous && number - previous > 1) withGaps.push("gap-" + number);
			withGaps.push(number);
		});
		return withGaps;
	}

	renderPageButton = number => {
		const { page, onChange } = this.props;
		if (typeof number === "string") {
			return (
				<span key={number} className="tools-pager__gap">
					…
				</span>
			);
		}
		const isCurrent = number === page;
		return (
			<button
				key={number}
				type="button"
				className={clsx("tools-pager__page", isCurrent && "tools-pager__page--current")}
				onClick={() => onChange({ page: number })}
				aria-current={isCurrent ? "page" : undefined}
				disabled={isCurrent}
			>
				{number}
			</button>
		);
	};

	render() {
		const { page, pageCount, pageSize, total, noun, nounPlural, summary, onChange } = this.props;
		const firstShown = total === 0 ? 0 : (page - 1) * pageSize + 1;
		const lastShown = Math.min(page * pageSize, total);
		const counted = UtilityService.describeCount({ count: total, singular: noun, plural: nounPlural });
		const shownText = total === 0 ? `No ${nounPlural || noun + "s"}` : `Showing ${firstShown}–${lastShown} of ${counted}`;

		return (
			<div className="tools-pager">
				<span className="tools-pager__summary">
					{shownText}
					{summary && <span className="tools-pager__summary-note"> · {summary}</span>}
				</span>
				{pageCount > 1 && (
					<span className="tools-pager__pages">
						<button
							type="button"
							className="tools-pager__page tools-pager__page--arrow"
							disabled={page <= 1}
							onClick={() => onChange({ page: page - 1 })}
							aria-label="Previous page"
						>
							<Icon.ChevronLeft size={14} />
						</button>
						{this.pageNumbersToShow().map(this.renderPageButton)}
						<button
							type="button"
							className="tools-pager__page tools-pager__page--arrow"
							disabled={page >= pageCount}
							onClick={() => onChange({ page: page + 1 })}
							aria-label="Next page"
						>
							<Icon.ChevronRight size={14} />
						</button>
					</span>
				)}
			</div>
		);
	}
}

export default ToolsPager;
